import contentMapping from './DataContentsMapping'
import cutoff_year from './Constants'
import _ from "lodash";

export default function dataContentLookup(dataList, year) {
    dataList.map(element => {
        //optionName from backend call in props is actually description
        //have to replace whitespace
        let mapKey = (year > cutoff_year.CUTOFF_ACADEMICYEAR) ?
            element.optionKey.replace(/\s/g, "") + "_" + year :
            element.optionName.replace(/\s/g, "") + "_" + year;
        // console.log(`debug element: `, element);
        // console.log(`debug mapKey: `, mapKey);
        // console.log(`debug optionName: `, element.optionName);
        // console.log(`debug contentMapping: `, contentMapping[mapKey]);

        if (!_.isNil(contentMapping[mapKey])) {
            element.from = contentMapping[mapKey][element.from];
            element.to = contentMapping[mapKey][element.to];
        }

        //changing Y/N to Yes/No
        switch (element.to) {
            case 'Y':
                element.to = contentMapping['Y'];
                break;
            case 'N':
                element.to = contentMapping['N'];
        }
        switch (element.from) {
            case 'Y':
                element.from = contentMapping['Y'];
                break;
            case 'N':
                element.from = contentMapping['N'];
        }

        element.application = year > cutoff_year.CUTOFF_ACADEMICYEAR ?
            (element.application && contentMapping[element.application.slice(0, -5)]) ?
                contentMapping[element.application.slice(0, -5)] + " " + element.application.slice(-5) : element.application :
            element.application ? contentMapping[element.application] : element.application;
    });
    return dataList;
}